import React, { useState } from 'react';
import './BrandedWork.css';
// import gallery1 from '../../assets/gallery1.jpeg';
// import gallery2 from '../../assets/gallery2.png';
// import gallery3 from '../../assets/gallery3.jpeg';
// import gallery4 from '../../assets/gallery4.png';
// import gallery5 from '../../assets/gallery5.png';
// import gallery6 from '../../assets/gallery6.png';
// import gallery7 from '../../assets/gallery7.png';
// import gallery8 from '../../assets/gallery8.png';
// import gallery9 from '../../assets/gallery9.png';
import elle1 from '../../assets/elle1.webp';
import elle2 from '../../assets/elle2.webp';
import elle3 from '../../assets/elle3.webp';
import elle4 from '../../assets/elle4.webp';
import elle5 from '../../assets/elle5.webp';
import elle6 from '../../assets/elle6.webp';
import elle7 from '../../assets/elle7.webp';
import elle8 from '../../assets/elle8.webp';
import elle9 from '../../assets/elle9.webp';
import elle10 from '../../assets/elle10.webp';
import elle11 from '../../assets/elle11.webp';
import elle12 from '../../assets/elle12.webp';
import elle13 from '../../assets/elle13.webp';
import offingMahreenSohail from '../../assets/offing-mahreen-sohail.webp';
import offingAruniKashyap from '../../assets/offing-aruni-kashyap.webp';
import offingLynneThompson from '../../assets/offing-lynne-thompson.webp';
import offingJessYuan from '../../assets/offing-jess-yuan.webp';
import offingSarahGhazalAli from '../../assets/offing-sarah-ghazal-ali.webp';
import offingSabaKeramati from '../../assets/offing-saba-keramati.webp';
import offingJacquiGermain from '../../assets/offing-jacqui-germain.webp';
import offingNatashaRao from '../../assets/offing-natasha-rao.webp';
import offingJoshuaNguyen from '../../assets/offing-joshua-nguyen.webp';
import Submenu from '../../components/Submenu';
import { editorialSections, fallbackEditorial } from '../../data/fallbackContent';
import { useContent } from '../../context/ContentContext';
import { withExternalLinks } from '../../utils/richText';

/* Used only when Airtable is unreachable, keyed by the names in fallbackContent. */
const bundledImages = {
  'elle1.webp': elle1,
  'elle2.webp': elle2,
  'elle3.webp': elle3,
  'elle4.webp': elle4,
  'elle5.webp': elle5,
  'elle6.webp': elle6,
  'elle7.webp': elle7,
  'elle8.webp': elle8,
  'elle9.webp': elle9,
  'elle10.webp': elle10,
  'elle11.webp': elle11,
  'elle12.webp': elle12,
  'elle13.webp': elle13,
  'offing-mahreen-sohail.webp': offingMahreenSohail,
  'offing-aruni-kashyap.webp': offingAruniKashyap,
  'offing-lynne-thompson.webp': offingLynneThompson,
  'offing-jess-yuan.webp': offingJessYuan,
  'offing-sarah-ghazal-ali.webp': offingSarahGhazalAli,
  'offing-saba-keramati.webp': offingSabaKeramati,
  'offing-jacqui-germain.webp': offingJacquiGermain,
  'offing-natasha-rao.webp': offingNatashaRao,
  'offing-joshua-nguyen.webp': offingJoshuaNguyen,
};

/*
 * One per half of the page. Section is the value a piece carries to claim the
 * column; the keys name the Site Content rows the column reads its wording from,
 * so both halves are written in Airtable rather than here.
 */
const COLUMNS = [
  {
    id: 'offing',
    section: editorialSections.offing,
    headingKey: 'editorial_offing_heading',
    introKey: 'editorial_offing_intro_html',
    linkLabelKey: 'editorial_offing_link_label',
  },
  {
    id: 'elle',
    section: editorialSections.elle,
    headingKey: 'editorial_elle_heading',
    introKey: 'editorial_elle_intro_html',
    linkLabelKey: 'editorial_elle_link_label',
    /* Where a piece goes when it names no section, or names one no column
       answers to, so a row can never quietly leave the page. */
    catchAll: true,
  },
];

/* Lenient about case and stray spaces, which a select value can pick up. */
const isSection = (value, section) => value.trim().toLowerCase() === section.toLowerCase();

const EditorialPiece = ({ piece, image, linkLabel }) => {
  const [isOpen, setIsOpen] = useState(false);
  const hasPanel = Boolean(piece.description || image);

  /* Nothing to reveal, so the row is the link itself rather than an empty drawer. */
  if (!hasPanel) {
    return (
      <li className="editorial-item">
        {piece.url ? (
          <a
            className="editorial-item-row"
            href={piece.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="editorial-item-title">{piece.title}</span>
            <span className="editorial-item-arrow" aria-hidden="true" />
          </a>
        ) : (
          <span className="editorial-item-row">
            <span className="editorial-item-title">{piece.title}</span>
          </span>
        )}
      </li>
    );
  }

  return (
    <li className={isOpen ? 'editorial-item editorial-item-open' : 'editorial-item'}>
      <button
        className="editorial-item-row"
        type="button"
        aria-expanded={isOpen}
        onClick={() => setIsOpen((open) => !open)}
      >
        <span className="editorial-item-title">{piece.title}</span>
        <span className="editorial-item-sign" aria-hidden="true" />
      </button>
      {isOpen && (
        <div className="editorial-panel">
          {image && (
            /* Alt is empty because the title above it already names the piece,
               and these are magazine layouts rather than photographs of anything
               a reader would otherwise miss. */
            <img
              className="editorial-panel-image"
              src={image}
              alt=""
              loading="lazy"
              decoding="async"
            />
          )}
          {piece.description && (
            <p className="editorial-panel-text">{piece.description}</p>
          )}
          {piece.url && (
            <a
              className="editorial-panel-link"
              href={piece.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {linkLabel}
            </a>
          )}
        </div>
      )}
    </li>
  );
};

const BrandedWork = () => {
  const { editorial, siteContent } = useContent();

  const named = (piece) => COLUMNS.some((column) => isSection(piece.section, column.section));
  const piecesIn = (pieces, column) => pieces
    .filter((piece) => (
      piece.section && named(piece)
        ? isSection(piece.section, column.section)
        : Boolean(column.catchAll)
    ))
    .sort((a, b) => a.sortOrder - b.sortOrder);

  const columns = COLUMNS
    .map((column) => {
      const fromTable = piecesIn(editorial, column);

      return {
        ...column,
        heading: siteContent[column.headingKey],
        intro: siteContent[column.introKey],
        linkLabel: siteContent[column.linkLabelKey],
        /*
         * A half the table has nothing for falls back to the pieces bundled
         * with the app, so the section holds its place until its rows are
         * written. It follows that emptying a section in Airtable brings the
         * bundled pieces back rather than clearing the half.
         */
        pieces: fromTable.length ? fromTable : piecesIn(fallbackEditorial, column),
      };
    })
    .filter((column) => column.pieces.length > 0);

  return (
    <>
      <div className="gallery">
        <Submenu />

        <h2>{siteContent.editorial_heading}</h2>
        {siteContent.editorial_intro && (
          <p className="editorial-intro">{siteContent.editorial_intro}</p>
        )}

        <div className="editorial-spread">
          {columns.map((column) => (
            <div className="editorial-column" key={column.id}>
              <h3 className="editorial-column-head">{column.heading}</h3>
              {/* Written as HTML in Airtable so the masthead can be named and
                  linked within the sentence, rather than the heading standing
                  in as a link to somewhere the reader cannot see. */}
              {column.intro && (
                <p
                  className="editorial-column-intro"
                  dangerouslySetInnerHTML={{ __html: withExternalLinks(column.intro) }}
                />
              )}
              <ul className="editorial-list">
                {column.pieces.map((piece) => (
                  <EditorialPiece
                    key={piece.id || piece.title}
                    piece={piece}
                    image={piece.imageUrl || bundledImages[piece.imageName]}
                    linkLabel={column.linkLabel}
                  />
                ))}
              </ul>
            </div>
          ))}
        </div>
        {/* <h2>Terribly Tiny Tales</h2>
        <div className="gallery-heading">
          As a copywriter, she told stories for over 30 brands, here are a few:
        </div>
        <div className="gallery-body">
          <div className="gallery-section">
            <div className="image-container">
              <img className="gallery-image" src={gallery1} alt="Mia by Tanishq" />
            </div>
            <div className="gallery-content">
              Client: Mia by Tanishq
              {' '}
              <br />
              With Mia by Tanishq we were celebrating the hopeless romantic in each of us.
              Crafted for Indian Working Women, this jewelry brand offers contemporary
              designs and we tried to encapture the modern love story to make the perfect gifts.
            </div>
          </div>
          <div className="gallery-section">
            <div className="image-container">
              <img className="gallery-image" src={gallery2} alt="UCB" />
            </div>
            <div className="gallery-content">
              Client: United Colors of Benetton
              {' '}
              <br />
              With UNITED COLORS OF BENETTON, we celebrated every yarn that unites us.
              Today, and for all days to come, we wrote under the campaign call
              may we be #UnitedByHope
            </div>
          </div>
          <div className="gallery-section">
            <div className="image-container">
              <img className="gallery-image" src={gallery3} alt="UCB" />
            </div>
            <div className="gallery-content">
              Client: United Colors of Benetton
              {' '}
              <br />
              With 50 dead and and over 53 injured at a gay club,
              the #OrlandoShootings make us question the extremes man
              can go to. And while we grieve in silence with our tongues
              tied in prayer, we unite to remember that when humanity
              joins hands, it’s always love that will triumph.
            </div>
          </div>
          <div className="gallery-section">
            <div className="image-container">
              <img className="gallery-image" src={gallery4} alt="Kohler" />
            </div>
            <div className="gallery-content">
              Client: Kohler
              {' '}
              <br />
              From allowing us to unleashing our inner singer to helping us get the best ideas, our bathrooms are spaces that let us be. With Kohler India, we penned tales on everything that can unfold in our home within home. #DreamInKohler at https://www.facebook.com/India.Kohler/
            </div>
          </div>
          <div className="gallery-section">
            <div className="image-container">
              <img className="gallery-image" src={gallery5} alt="Cornetto" />
            </div>
            <div className="gallery-content">
              Client: Cornetto
              {' '}
              <br />
              Love is universal, but also very, very individual.
              With @cornettoindia #ShowYourLove as you weave.
            </div>
          </div>
          <div className="gallery-section">
            <div className="image-container">
              <img className="gallery-image" src={gallery6} alt="Burger King" />
            </div>
            <div className="gallery-content">
              Client: Burger King
              {' '}
              <br />
              Got what it takes to #SurviveTheAngriest?
              We wrote to advertise sales for The Angriest Whopper, at your
              nearest Burger King outlet. May the fire be with you.
            </div>
          </div>
          <div className="gallery-section">
            <div className="image-container">
              <img className="gallery-image" src={gallery7} alt="Goodnight" />
            </div>
            <div className="gallery-content">
              Client: Goodnight
              {' '}
              <br />
              We’re celebrating Mother’s Weekend, and bringing you a heartful of
              laughs, tears, goose bumps and nostalgia.
            </div>
          </div>
          <div className="gallery-section">
            <div className="image-container">
              <img className="gallery-image" src={gallery8} alt="OneTouch" />
            </div>
            <div className="gallery-content">
              Client: One Touch
              {' '}
              <br />
              Families are pools. For glee, grief and their stories. They fill roofs with
              lessons and rooms with joy. With this brand, we dwelled in this sweetness.
              Because #FamilyMatters
              To safeguard these sweet moments from diabetes, visit: www.onetouchdiabetes.co.in
            </div>
          </div>
          <div className="gallery-section">
            <div className="image-container">
              <img className="gallery-image" src={gallery9} alt="OneTouch" />
            </div>
            <div className="gallery-content">
              Client: WaveNote
              {' '}
              <br />
              With this brand we were writing audio stories, to gather submissions
              for their ongoing spoken word contest and promote their newly launched application.
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default BrandedWork;
